const setupResetAddressComponentsButton = (input) => {
  getElement(input.id, "address-lookup-reset-selection").addEventListener(
    "click",
    () => {
      input.value = "";
      getElement(input.id, "address-lookup-details").classList.add("d-none");
      updateAddressComponentsInputs(input.id, {});
      enableLookupField(input);
    },
  );
};

const updateAddressComponentsSummary = (
  elementId,
  { streetAddress, city, country, postalCode },
) => {
  getElement(elementId, "address-lookup-summary-street_address").innerText =
    streetAddress;
  getElement(elementId, "address-lookup-summary-city").innerText = city;
  getElement(elementId, "address-lookup-summary-postal_code").innerText =
    postalCode;
  getElement(elementId, "address-lookup-summary-country").innerText = country;
};

const updateAddressComponentsInputs = (
  elementId,
  { streetAddress, city, stateOrCountry, country, postalCode },
) => {
  document.getElementById(`${elementId}-street_address`).value =
    streetAddress || "";
  document.getElementById(`${elementId}-city`).value = city || "";
  document.getElementById(`${elementId}-state_or_county`).value =
    stateOrCountry || "";
  document.getElementById(`${elementId}-country`).value = country || "";
  document.getElementById(`${elementId}-postal_code`).value = postalCode || "";
};

const showAddressLookupDetailsBlock = (elementId) => {
  getElement(elementId, "address-lookup-details").classList.remove("d-none");
};

const hideAddressLookupDetailsBlock = (elementId) => {
  getElement(elementId, "address-lookup-details").classList.add("d-none");
};

const disableLookupField = (input) => {
  input.disabled = true;
};

const enableLookupField = (input) => {
  input.disabled = false;
};

const addressComponent = (addressComponents, keys) => {
  if (keys == null || keys.length == 0) return "";

  const [key, ...nextKeys] = keys;
  const component = addressComponents.find(({ types }) => types[0] == key);

  if (component == null) return addressComponent(addressComponents, nextKeys);

  return component.long_name;
};

const getElement = (elementId, role) =>
  document.querySelector(`[data-element="${role}"][data-id="${elementId}"]`);

function init_input(input) {
  if (input == null) return;

  const elementId = input.id;
  const country = input.dataset.country;
  var autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.setComponentRestrictions({
    country: [country],
  });

  setupResetAddressComponentsButton(input);

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (place?.address_components == null) return;

    let streetAddress = "";
    let city = addressComponent(place.address_components, [
      "locality",
      "postal_town",
      "administrative_area_level_3",
    ]);
    let stateOrCountry = "";
    let country = "";
    let postalCode = "";

    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number":
          streetAddress = `${component.long_name} ${streetAddress}`;
          break;

        case "route":
          streetAddress += component.short_name;
          break;

        case "postal_code":
          postalCode = component.long_name;
          break;

        case "administrative_area_level_1": {
          stateOrCountry = component.short_name;
          break;
        }

        case "country":
          country = component.long_name;
          break;
      }
    }

    const components = {
      streetAddress,
      city,
      stateOrCountry,
      country,
      postalCode,
    };

    updateAddressComponentsSummary(elementId, components);
    updateAddressComponentsInputs(elementId, components);
    showAddressLookupDetailsBlock(elementId);
    disableLookupField(input);
  });
}

export function init(form_container) {
  const inputs = form_container.querySelectorAll("[data-auto-complete]");

  if (inputs.length > 0) {
    [...inputs].forEach((autocomplete_input) => {
      init_input(autocomplete_input);
    });
  }
}
